export default __webpack_public_path__ + "static/media/nexus-logo-stacked.4d63a393.svg";